import { createContext, useContext } from 'react';

// @ts-ignore
export const SessionContext = createContext();

export const useSessionContext = () => useContext(SessionContext);
